import React, { useState } from 'react'
import GeoLevelFilter from './GeoLevelFilter';
import TabSearch from './TabSearch';
import UserList from './UserList';
import { Drawer } from 'antd';
import ManageUsersFilter from '../../Drawer/ManageUsersFilter';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../../Action';
import EditUserRole from '../../Drawer/EditUserRole';
import AdminRootFilter from '../../adminRootFilter/AdminRootFilter';

export default function Index() {
  const [isOpen, setIsOpen] = useState(true);
  const dispatch = useDispatch();
  const {drawerOpenMU} = bindActionCreators(Actions, dispatch)
  const adminManageUserState = useSelector(state=>state.manageUsers)
  return (
    <div className='mb-5' style={{margin:'auto',width:'95%', marginTop:'-0.5%'}}>
        <div className='mt-2'>
        <AdminRootFilter/>
        </div>
        <TabSearch/>
        <UserList/>
        <Drawer open={adminManageUserState.isDrawerOpen===0?false:true} onClose={()=>drawerOpenMU(0)} width={adminManageUserState.isDrawerOpen===1?'40%':adminManageUserState.isDrawerOpen===2?'40%':'auto'}>
         {adminManageUserState.isDrawerOpen===1 &&<ManageUsersFilter/>}
         {adminManageUserState.isDrawerOpen===2 &&<EditUserRole/>}
        </Drawer>
    </div>
  )
}
